// extracted by mini-css-extract-plugin
export var actionText = "_rf-4";
export var container = "_rf-0";
export var leftSection = "_rf-1";
export var rightSection = "_rf-2";
export var settingsButton = "_rf-6";
export var settingsIcon = "_rf-7";
export var shortcut = "_rf-5";
export var shortcutGroup = "_rf-3";